import * as React from 'react';
import styled from 'styled-components';
import { Typography } from '../DesignSystemV2/Typography';
import { ResponsiveTypography } from '../Typography/v3/ResponsiveTypography';

interface Props {
  title: string;
  children: React.ReactNode;
  totalOptions?: number;
}
const Header = styled.div`
  padding: 0 14px;
`;
const Wrapper = styled.div`
  padding: 16px 0;
  max-height: 100%;

  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  grid-row-gap: 16px;
`;

export const OptionListWithTitleLayout = React.forwardRef<HTMLDivElement, Props>(
  ({ title, children, totalOptions }: Props, ref) => {
    return (
      <Wrapper ref={ref}>
        <Header>
          <Typography.Text variant="semi-bold/16-28">{title}</Typography.Text>
          {totalOptions && (
            <ResponsiveTypography.Paragraph variant="semi-bold/12-16" color="gray100">
              {totalOptions} OPTIONS
            </ResponsiveTypography.Paragraph>
          )}
        </Header>
        {children}
      </Wrapper>
    );
  }
);
